module.exports = __webpack_public_path__ + "static/img/icon1.f4e39dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon1.png
// module id = zTt2
// module chunks = 21